(function () {
  'use strict';

  angular
    .module('rosterStatusReportRadarChart')
    .service('rosterStatusReportRadarChartService', rosterStatusReportRadarChartService);

  function rosterStatusReportRadarChartService(CommonMasterData,RemoteService) {
    var vm = this;

    vm.searchRosterStatusReportRadarChart = function (param ,successFn,errorFn) {
      var searchParam = adaptSearchRequset(param);
      RemoteService.searchRosterStatusReportRadarChart(searchParam).then(
        function (response) {
          successFn(response);
        },
        function (error) {
          errorFn(error.msg);
        }
      );
    };

    function adaptSearchRequset(param) {
      var actualSearchParam = {
        autoScheduleId : param.autoScheduleSetupId,
      };

      return actualSearchParam;
    }

  }
}());
